import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { HttpInterceptorService, ErrorInterceptorService } from './core';
import { LoginComponent } from './auth/login/login.component';
import { FooterComponent } from './main/footer/footer.component';
import { HeaderComponent } from './main/header/header.component';
import { SidebarComponent } from './main/sidebar/sidebar.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { ProfileComponent } from './auth/profile/profile.component';
import { DashboardComponent } from './main/dashboard/dashboard.component';
import { PaymentHistoryComponent } from './main/payment-history/payment-history.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ComplaintComponent } from './auth/complaint/complaint.component';
import { FaqComponent } from './auth/faq/faq.component';
import { ContactUsComponent } from './auth/contact-us/contact-us.component';
import { PrivacyPolicyComponent } from './auth/privacy-policy/privacy-policy.component';
import { RefundPolicyComponent } from './auth/refund-policy/refund-policy.component';
import { TermsComponent } from './auth/terms/terms.component';
import { HomeComponent } from './auth/home/home.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { SearchPipe } from './search.pipe';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BootstrapModule } from './main/bootstrap/bootstrap.module';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { LOADING_BAR_CONFIG } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { NotFoundComponent } from './auth/not-found/not-found.component';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import {TwoFactorModule} from "./two-factor/two-factor.module";
import {ModalModule} from "ngx-bootstrap/modal";
import {SharedModule} from "./shared/shared.module";
import {SECURE_STORAGE_CONFIG, StorageConfig} from "ngx-secure-storage";
import {environment} from "../environments/environment";
import {NETWORK_MONITOR_CONFIG, NetworkMonitorConfig} from "ngx-network-monitor";
import { NetworkIndicatorComponent } from './network-indicator/network-indicator.component';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    SidebarComponent,
    HomeComponent,
    LoginComponent,
    ChangePasswordComponent,
    ResetPasswordComponent,
    ProfileComponent,
    DashboardComponent,
    PaymentHistoryComponent,
    ComplaintComponent,
    FaqComponent,
    ContactUsComponent,
    PrivacyPolicyComponent,
    RefundPolicyComponent,
    TermsComponent,
    SearchPipe,
    NotFoundComponent,
    NetworkIndicatorComponent,
  ],
  imports: [
    AppRoutingModule,
    CommonModule,
    HttpClientModule,
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    BootstrapModule,
    MDBBootstrapModule.forRoot(),
    LoadingBarHttpClientModule,
    LoadingBarRouterModule,
    LoadingBarModule,
    TwoFactorModule,
    ModalModule.forRoot(),
    SharedModule,

  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true },
    { provide: LOADING_BAR_CONFIG, useValue: { latencyThreshold: 100 } },
    { provide: NETWORK_MONITOR_CONFIG, useValue: { pingUrl: '/assets/ping.txt' } as NetworkMonitorConfig },
    { provide: SECURE_STORAGE_CONFIG, useValue: {
      encryptionKey: environment.localStorageEncryptionKey,
        disableInDev: true,
        prefix: '_CDE_'
      } as StorageConfig }

  ],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA]

})
export class AppModule { }
